import ApplicationController from "./application_controller"

export default class RenderingSdkListController extends ApplicationController {
  static targets = ["input", "listField", "itemsList", "selectedCount", "clearLink", "suggestions"]
  static values = {suggestions: Array}

  connect() {
    this.renderItems()
    document.addEventListener('click', this.hideSuggestions.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.hideSuggestions.bind(this))
  }

  getItems() {
    const value = this.listFieldTarget.value.trim()
    if (value === '') return []
    return value.split(',').map(s => s.trim()).filter(s => s !== '')
  }

  setItems(items) {
    this.listFieldTarget.value = items.join(',')
    this.renderItems()
  }

  add(event) {
    event.preventDefault()
    const newItem = this.inputTarget.value.trim()
    if (newItem === '') return

    const items = this.getItems()
    if (items.map(i => i.toLowerCase()).includes(newItem.toLowerCase())) {
      this.inputTarget.value = ''
      this.hideSuggestions()
      return
    }

    items.push(newItem)
    this.setItems(items)
    this.inputTarget.value = ''
    this.inputTarget.focus()
    this.hideSuggestions()
  }

  toggle(event) {
    const checkbox = event.currentTarget
    const item = checkbox.dataset.item
    let items = this.getItems()

    if (checkbox.checked) {
      if (!items.includes(item)) {
        items.push(item)
      }
    } else {
      items = items.filter(i => i !== item)
    }

    this.setItems(items)
  }

  clearAll(event) {
    event.preventDefault()
    this.setItems([])
  }

  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.add(event)
    } else if (event.key === 'Escape') {
      this.hideSuggestions()
    } else if (event.key === 'ArrowDown') {
      event.preventDefault()
      this.focusNextSuggestion()
    } else if (event.key === 'ArrowUp') {
      event.preventDefault()
      this.focusPrevSuggestion()
    }
  }

  onInput(event) {
    const query = event.target.value.trim().toLowerCase()
    if (query.length === 0) {
      this.hideSuggestions()
      return
    }

    const currentItems = this.getItems().map(i => i.toLowerCase())
    const filtered = this.suggestionsValue
      .filter(s => s.toLowerCase().includes(query))
      .filter(s => !currentItems.includes(s.toLowerCase()))
      .slice(0, 10)

    if (filtered.length === 0) {
      this.hideSuggestions()
      return
    }

    this.showSuggestions(filtered)
  }

  showSuggestions(suggestions) {
    if (!this.hasSuggestionsTarget) return

    this.suggestionsTarget.innerHTML = suggestions.map(s => `
      <div class="suggestion-item" style="padding: 5px 10px; cursor: pointer;" data-action="click->rendering-sdk-list#selectSuggestion" data-value="${this.escapeHtml(s)}">
        ${this.escapeHtml(s)}
      </div>
    `).join('')

    this.suggestionsTarget.style.display = 'block'
  }

  hideSuggestions(event) {
    if (event && this.element.contains(event.target)) return
    if (this.hasSuggestionsTarget) {
      this.suggestionsTarget.style.display = 'none'
    }
  }

  selectSuggestion(event) {
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value
    this.add(event)
  }

  focusNextSuggestion() {
    if (!this.hasSuggestionsTarget) return
    const items = this.suggestionsTarget.querySelectorAll('.suggestion-item')
    const focused = this.suggestionsTarget.querySelector('.suggestion-item:focus')
    if (focused) {
      const index = Array.from(items).indexOf(focused)
      if (index < items.length - 1) items[index + 1].focus()
    } else if (items.length > 0) {
      items[0].focus()
    }
  }

  focusPrevSuggestion() {
    if (!this.hasSuggestionsTarget) return
    const items = this.suggestionsTarget.querySelectorAll('.suggestion-item')
    const focused = this.suggestionsTarget.querySelector('.suggestion-item:focus')
    if (focused) {
      const index = Array.from(items).indexOf(focused)
      if (index > 0) items[index - 1].focus()
    }
  }

  renderItems() {
    const items = this.getItems()

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = items.length ? `${items.length} selected` : 'none'
    }

    if (this.hasClearLinkTarget) {
      this.clearLinkTarget.style.display = items.length > 0 ? 'inline' : 'none'
    }

    if (this.hasItemsListTarget) {
      if (items.length === 0) {
        this.itemsListTarget.innerHTML = ''
      } else {
        this.itemsListTarget.innerHTML = items.map(item => `
          <label class="checkbox-label" style="display: block; margin: 2px 0;">
            <input type="checkbox" checked data-action="rendering-sdk-list#toggle" data-item="${this.escapeHtml(item)}">
            <span>${this.escapeHtml(item)}</span>
          </label>
        `).join('')
      }
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
